export enum LocalStorageKeys {
  SHOULD_SHOW_DEACTIVATED_PAGE = 'shouldShowDeactivatedPage',
}
